import React, { useState } from "react";
import axios from "axios";


const useBillPaymentClass = ({
    onFinish = () => { }, //{ axiosMode, status, values }
    onBefore = () => { }, //{ axiosMode, status }
}) => {
    const mainApi = `/cramSchool/api/bill_payment/class`
    const [data, setData] = useState([])
    const [option, setOption] = useState([])
    const calculateBillPaymentClass = (data) => {
        axios.post('/cramSchool/api/bill_payment_grade_class/calculate',
            data
        )
            .then((response) => {
                let calculateData = response.data
                if (calculateData) {
                    onFinish(
                        {
                            axiosMode: "postCalculate",
                            status: "success",
                            values: calculateData
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "postCalculate",
                            status: "error",
                            values: calculateData
                        }
                    )
                }
            });
    }
    const getBillPaymentClassOption = () => {
        axios.get('/cramSchool/api/bill_payment/class', {
            params: {

            },
        })
            .then((response) => {
                let data = response.data.data
                setOption((pre) => {
                    return data.map((value) => {
                        return {
                            ...value,
                            label: value?.name,
                            value: value?.class_id
                        }
                    })
                })
            });
    }
    const getBillPaymentClassData = ({
        cur_page,
        size,
        class_id,
        year,
        custom_filter_key,
        custom_filter_value,
        
    }) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/cramSchool/api/bill_payment/class', {
            params: {
                cur_page,
                size,
                class_id,
                year,
                custom_filter_key,
                custom_filter_value,
            },
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }

    const postBillPaymentClassData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/cramSchool/api/bill_payment_grade_class',
            data
        )
            .then((response) => {
                let responseData = response.data
                console.log({ responseData })
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    const patchBillPaymentClassData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteBillPaymentClassData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        BillPaymentClassData: data,
        BillPaymentClassOption: option,
        calculateBillPaymentClass,
        getBillPaymentClassOption,
        getBillPaymentClassData,
        postBillPaymentClassData,
        patchBillPaymentClassData,
        deleteBillPaymentClassData
    }
}
export { useBillPaymentClass }
